import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { cloneDeep } from 'lodash-es';
import { DocumentSearchResult } from '../../document/models/documentSearchResult';
import { LinkedDocument } from '../../shared/models/linked-documents';
import { DocumentLibraryConstants } from '../../document/document-library-constants';
import { DocumentLibrarySearchComponent } from '../../document-search/document-library-search/document-library-search.component';
import { DocumentCommonService } from '../../shared/services/document-common.service';
import { CommonModule } from '@angular/common';
import { FieldsetModule } from 'primeng/fieldset';
import { ButtonModule } from 'primeng/button';
import { DocumentSearchModule } from '../../document-search/document-search.module';
import { DialogModule } from 'primeng/dialog';
import { MessagesModule } from 'primeng/messages';
import { DocumentPersistenceService } from '../../document/services/document-persistence.service';
import { ChangecontrolPersistenceService } from '../../change-control/change-control-library/services/changecontrol-persistence.service';
import { SharedModule } from '../../shared/shared.module';


@Component({
  selector: 'app-related-documents',
  standalone: true,
  imports: [CommonModule, MessagesModule,FieldsetModule, ButtonModule, DocumentSearchModule, DialogModule, SharedModule],
  templateUrl: './related-documents.component.html',
  styleUrls: ['./related-documents.component.scss']
})
export class RelatedDocumentsComponent implements OnInit {
  @Output() relatedDocumentsSave = new EventEmitter();
  @Output() moveToPreviousTab = new EventEmitter();
  @Output() relatedDocumentsAddition = new EventEmitter();
  @Input()  linkedDocuments: LinkedDocument[] = [];
  @Input() relatedDocumentsNotAlignedWithScopeConfirmationMessage !: string
  @Input() documentNumbersNotAlignedWithParentDocument!: string[];
  @Input() errorMessages!: string[];
  @Input() showRelatedDocumentsNotAlignedWithScopeConfirmationModal: boolean = false;
  @Input() showDocumentLibrarySearch!: boolean;
  @Input() panelListScreen!:string;

  showAddRelatedDocumentBtn: boolean = false;
  selectedDocuments: DocumentSearchResult[] = [];
    heading : string = DocumentLibraryConstants.ReasonHeading;
  isLinkedDocumentsAvailable: boolean = false;
  @ViewChild(DocumentLibrarySearchComponent)
  private documentLibrarySearchComponent!: DocumentLibrarySearchComponent;
  constructor(
    private documentCommonService: DocumentCommonService,
    private documentPersistenceService: DocumentPersistenceService,
    private changeControlPersistenceService : ChangecontrolPersistenceService,
    private confirmationService: ConfirmationService,
    private router: Router) { }

  ngOnInit(): void {
    this.documentPersistenceService.closeAndResetDocumentSlider$.subscribe(
      (isClose) => {
        if (isClose) {
          this.resetRelatedDocuments();
        }
      }
    );
    this.changeControlPersistenceService.closeAndResetChangeControlSlider$.subscribe(
      (isClose) => {
        if (isClose) {
          this.resetRelatedDocuments();
        }
      }
    );
  }
  

  showOrHideAddRelatedDocumentButton = (displayAddRelatedDocumentBtn: boolean) => {
    this.showAddRelatedDocumentBtn = displayAddRelatedDocumentBtn;
  }

  openPreviousTab = () => {
    this.moveToPreviousTab.emit()
  }

  onSelectionOrDeselection = (documents: DocumentSearchResult[]) => {
    this.selectedDocuments = [];
    this.selectedDocuments = cloneDeep(documents);
  }

  updateRelatedDocumentList = () => {
    this.getEffectiveOrLatestVersionOfSelectedDocuments();
    this.closeRelatedDocumentsNotAlignedWithScopeConfirmationModal();
  }

  deleteRelatedDocument = (documentNumber: string) => {
    this.linkedDocuments = this.linkedDocuments?.filter((document) => { return document.number !== documentNumber });
  }

  getEffectiveOrLatestVersionOfSelectedDocuments = () => {
    let selectedDocumentNumbers: string[] = this.selectedDocuments.map((document) => document.documentNumber);
    this.documentCommonService.getEffectiveOrLatestVersionOfDocuments(selectedDocumentNumbers)
      .subscribe((linkedDocuments: LinkedDocument[]) => {
        this.linkedDocuments = this.linkedDocuments != null? [...this.linkedDocuments, ...linkedDocuments] : linkedDocuments;
        this.clearSelection();
      });
  }

  clearSelection(){
    this.documentLibrarySearchComponent.getLinkedItemsSelection();
  }

  loadDocumentDetails = (documentNumber: string, version: number) => {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([
        '/eqms.documentDetails/' + documentNumber + ':' + version,
      ])
    );
    window.open(url, '_blank');
  };

  openDeleteConfirmationModal = (documentNumber: string) => {
    this.confirmationService.confirm({
      header: DocumentLibraryConstants.Document_Slider_Confirmation_Header,
      message: DocumentLibraryConstants.RelatedDocuments_Delete_ConfirmationMessage,
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.deleteRelatedDocument(documentNumber);
      },
    });

  }

  resetRelatedDocuments = () => {
    this.showDocumentLibrarySearch = false;
    this.errorMessages = [];
    this.linkedDocuments = [];
    this.showAddRelatedDocumentBtn = false;
    this.selectedDocuments = [];
    this.showRelatedDocumentsNotAlignedWithScopeConfirmationModal = false;
  }

  trackByDocumentNumber = (index: number, document: LinkedDocument) => {
    return document.number;
  }
  closeRelatedDocumentsNotAlignedWithScopeConfirmationModal = () => {
    this.showRelatedDocumentsNotAlignedWithScopeConfirmationModal = false;
  }

  saveRelatedDocuments(){
    this.relatedDocumentsSave.emit()
  }

  addRelatedDocuments(){
    this.relatedDocumentsAddition.emit()
    this.isLinkedDocumentsAvailable = true;
  }
}
